import { defineComponent as _defineComponent } from 'vue'
import { I18NGetter } from '@/services/enumTranslator/I18NGetter';
import NpsDataTable from '@/modules/nps/views/NPSDataTable.vue';
import NavigationHeader from '@/components/NavigationHeader/NavigationHeader.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'NPSList',
  setup(__props) {


return { __sfc: true,I18NGetter, NpsDataTable, NavigationHeader }
}

})